(function () {
  'use strict';

  /* @ngdoc object
   * @name exports.edit
   * @description
   *
   */
  angular
    .module('fertilization.nDemandExports.edit', [
      'ui.router'
    ]);
}());
